import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import type { MediaComponentType } from '@unifyapps/defs/blocks/Media/types';
import { lazy } from 'react';

const importMediaComponent = () =>
  import(
    /* webpackChunkName: "media-block" */
    './Media'
  );

const Media = lazy(importMediaComponent);

class MediaBlockStateDefinition implements BlockStateDefinition {
  getComponent() {
    return Media;
  }
  preload() {
    return {
      blockPreload: importMediaComponent,
    };
  }

  get type(): ComponentTypeUnionType {
    return 'Media';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component as MediaComponentType, ['content', 'appearance', 'componentType']),
      }) as BlockStateUnionType;
  }
}

export default MediaBlockStateDefinition;
